import { Action } from "redux"

export const INITIALIZE = "SMARTLOCATION_INITIALIZE"
export const REQUEST_SIBLINGS = "SMARTLOCATION_REQUEST_SIBLINGS"
export const RECEIVE_SIBLINGS = "SMARTLOCATION_RECEIVE_SIBLINGS"
export const UPDATE_SIBLINGS_VISIBILITY =
    "SMARTLOCATION_UPDATE_SIBLINGS_VISIBILITY"
export const REORDER_SIBLINGS = "SMARTLOCATION_REORDER_SIBLINGS"
export const REMOVE_SIBLING = "SMARTLOCATION_REMOVE_SIBLING"
export const FILTER_SIBLINGS = "SMARTLOCATION_FILTER_SIBLINGS"
export const LOAD_MORE_SIBLINGS = "SMARTLOCATION_LOAD_MORE_SIBLINGS"
export const SET_CURRENT_SIBLING = "SMARTLOCATION_SET_CURRENT_SIBLING"

export interface Initialize extends Action {
    breadcrumbs?: SmartLocation.Breadcrumb[]
}

export const initialize = (props: SmartLocation.SmartLocation): Initialize => ({
    type: INITIALIZE,
    ...props,
})

export const requestSiblings = (): Action => ({ type: REQUEST_SIBLINGS })

interface Meta {
    More: boolean
}

export interface ReceiveSiblings extends Action {
    Data?: SmartLocation.Sibling[] | null
    Meta?: Meta | null
}

export const receiveSiblings = (
    Data: SmartLocation.Sibling[],
    Meta: Meta,
): ReceiveSiblings => ({ type: RECEIVE_SIBLINGS, Data, Meta })

export interface UpdateSiblingsVisibility extends Action {
    siblingsShown: boolean
}

export const updateSiblingsVisibility = (
    siblingsShown: boolean,
): UpdateSiblingsVisibility => ({
    type: UPDATE_SIBLINGS_VISIBILITY,
    siblingsShown,
})

export interface ReorderSiblings extends Action {
    targetLocation: number
    oldLocation: number
    reorderedSiblingId: string
    targetSiblingId: string
}

export const reorderSiblings = (
    targetLocation: number,
    oldLocation: number,
    reorderedSiblingId: string,
    targetSiblingId: string,
): ReorderSiblings => ({
    type: REORDER_SIBLINGS,
    targetLocation,
    oldLocation,
    reorderedSiblingId,
    targetSiblingId,
})

export interface RemoveSibling extends Action {
    selectionFilterId: string
}

export const removeSibling = (selectionFilterId: string): RemoveSibling => ({
    type: REMOVE_SIBLING,
    selectionFilterId,
})

export interface FilterSibling extends Action {
    filter: string
}

export const filterSiblings = (filter: string): FilterSibling => ({
    type: FILTER_SIBLINGS,
    filter,
})

export interface LoadMoreSiblings extends Action {
    lastSiblingId: string
}

export const loadMoreSiblings = (lastSiblingId: string): LoadMoreSiblings => ({
    type: LOAD_MORE_SIBLINGS,
    lastSiblingId,
})

export const mapDispatchToProps = {
    initialize,
    updateSiblingsVisibility,
    requestSiblings,
    receiveSiblings,
    reorderSiblings,
    removeSibling,
    filterSiblings,
    loadMoreSiblings,
}

export type DispatchProps = typeof mapDispatchToProps
